import { render, staticRenderFns } from "./DownloadIcon2.vue?vue&type=template&id=878e7e3e"
import script from "./DownloadIcon2.vue?vue&type=script&lang=js"
export * from "./DownloadIcon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports